import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import type { Delivery } from '@/services/db/delivery/entity';
import { ActionCell } from './cells/action-cell';
import { DateCell } from './cells/date-cell';
import { RecipientCell } from './cells/recipient-cell';
import { StatusCell } from './cells/status-cell';
import { StatusHeader } from './status-header';

const helper = createColumnHelper<Delivery>();

export type DeliveryColumnsOptions = {
  channels: readonly string[];
  actionType: string;
  getDeliveryHref: (delivery: Delivery) => string;
  /** Header for the recipient column (the person taxonomy term varies by plan). */
  recipientHeader: string;
};

/** The four deliveries columns (Date Created, Action, Recipient, Status). Not sortable — matches Ember. */
export function createDeliveryColumns({
  channels,
  actionType,
  getDeliveryHref,
  recipientHeader,
}: DeliveryColumnsOptions): ColumnDef<Delivery>[] {
  return [
    helper.display({
      id: 'date',
      header: 'Date Created',
      cell: (info) => <DateCell delivery={info.row.original} />,
    }),
    helper.display({
      id: 'action',
      header: 'Action',
      cell: (info) => <ActionCell delivery={info.row.original} getDeliveryHref={getDeliveryHref} />,
    }),
    helper.display({
      id: 'recipient',
      header: recipientHeader,
      cell: (info) => <RecipientCell delivery={info.row.original} />,
    }),
    helper.display({
      id: 'status',
      header: () => <StatusHeader channels={channels} actionType={actionType} />,
      meta: { align: 'end' },
      cell: (info) => <StatusCell delivery={info.row.original} />,
    }),
  ];
}
